// extracted by mini-css-extract-plugin
module.exports = {"subContainer":"e_YA","credits":"e_ZA","badgeContainer":"e__A","badge":"e_0A"};